import axios from 'axios';
import { TIME_5000 } from '@/shared/constants/services-const';
import handlerErrorFromApis from './errorHandler.js';

const createApiInstance = (baseURL) => {
    return axios.create({
        baseURL: baseURL,
        timeout: TIME_5000,
    });
};

const userApiInstance = createApiInstance(process.env.VUE_APP_AUTH_API);
const sportsApiInstance = createApiInstance(process.env.VUE_APP_CLICK_API);
const fantasyApiInstance = createApiInstance(process.env.VUE_APP_FANTACY_API);
const poolApiInstance = createApiInstance(process.env.VUE_APP_POOL_API);
const bonusApiInstance = createApiInstance(process.env.VUE_APP_BONUS_API);
const notificationApiInstance = createApiInstance(process.env.VUE_APP_NOTIFICATION_API);

const apiInstances = {
    user: userApiInstance,
    sports: sportsApiInstance,
    fantasy: fantasyApiInstance,
    pool: poolApiInstance,
    bonus: bonusApiInstance,
    notification: notificationApiInstance
}

Object.values(apiInstances).forEach(instance => {
    instance.interceptors.response.use(
        response => Promise.resolve(response),
        error => handlerErrorFromApis(error)
    );
});

export default apiInstances;